/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_task_document_task__task_id__documents_post } from '../models/Body_upload_task_document_task__task_id__documents_post';
import type { Body_upload_task_image_task__task_id__images_post } from '../models/Body_upload_task_image_task__task_id__images_post';
import type { DocumentEmailRequest } from '../models/DocumentEmailRequest';
import type { Task } from '../models/Task';
import type { TaskActionResponse } from '../models/TaskActionResponse';
import type { TaskChangeLog } from '../models/TaskChangeLog';
import type { TaskCreate } from '../models/TaskCreate';
import type { TaskDocument } from '../models/TaskDocument';
import type { TaskImage } from '../models/TaskImage';
import type { TaskImageBase64 } from '../models/TaskImageBase64';
import type { TaskRestoreRequest } from '../models/TaskRestoreRequest';
import type { TaskRestoreResponse } from '../models/TaskRestoreResponse';
import type { TaskUpdate } from '../models/TaskUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TasksService {

    /**
     * Get Tasks
     * Get all tasks with optional filtering.
 *
 * - **skip**: Number of tasks to skip (pagination)
 * - **limit**: Maximum number of tasks to return
 * - **assigned_to**: Filter by assigned user ID
 * - **bauvorhaben_id**: Filter by building project ID
 * - **status**: Filter by task status
 * - **include_archived**: Include archived tasks in results (default: false)
     * @param skip 
     * @param limit 
     * @param assignedTo 
     * @param bauvorhabenId 
     * @param status 
     * @param includeArchived 
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static getTasksTaskGet(
skip?: number,
limit: number = 100,
assignedTo?: number,
bauvorhabenId?: number,
status?: string,
includeArchived: boolean = false,
): CancelablePromise<Array<Task>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/',
            query: {
                'skip': skip,
                'limit': limit,
                'assigned_to': assignedTo,
                'bauvorhaben_id': bauvorhabenId,
                'status': status,
                'include_archived': includeArchived,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Task
     * @param requestBody 
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static createTaskTaskPost(
requestBody: TaskCreate,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get My Tasks
     * Get all tasks assigned to the requesting user.
 *
 * - **skip**: Number of tasks to skip (pagination)
 * - **limit**: Maximum number of tasks to return
 * - **status**: Filter by task status
 * - **include_archived**: Include archived tasks in results (default: false)
     * @param skip 
     * @param limit 
     * @param status 
     * @param includeArchived 
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static getMyTasksTaskMeGet(
skip?: number,
limit: number = 100,
status?: string,
includeArchived: boolean = false,
): CancelablePromise<Array<Task>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/me',
            query: {
                'skip': skip,
                'limit': limit,
                'status': status,
                'include_archived': includeArchived,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Task
     * @param taskId The ID of the task to retrieve
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static getTaskTaskTaskIdGet(
taskId: number,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Task
     * @param taskId The ID of the task to update
     * @param requestBody 
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static updateTaskTaskTaskIdPut(
taskId: number,
requestBody?: TaskUpdate,
): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Task
     * Archive (soft delete) a task. The task will be marked as ARCHIVED instead of being permanently deleted.
 * Only the creator of the task or admins can archive tasks.
 *
 * - **task_id**: The ID of the task to archive
     * @param taskId The ID of the task to delete
     * @returns TaskActionResponse Successful Response
     * @throws ApiError
     */
    public static deleteTaskTaskTaskIdDelete(
taskId: number,
): CancelablePromise<TaskActionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Task Changelog
     * Get changelog for a specific task
     * @param taskId The ID of the task to get changelog for
     * @returns TaskChangeLog Successful Response
     * @throws ApiError
     */
    public static getTaskChangelogTaskTaskIdChangelogGet(
taskId: number,
): CancelablePromise<Array<TaskChangeLog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/{task_id}/changelog',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Permanently Delete Task
     * Permanently delete a task and all its associated data (images, documents, changelog).
 * This is irreversible! Only archived tasks can be permanently deleted.
 * Only the creator of the task or admins can permanently delete tasks.
 *
 * - **task_id**: The ID of the task to permanently delete
     * @param taskId The ID of the task to permanently delete
     * @returns TaskActionResponse Successful Response
     * @throws ApiError
     */
    public static permanentlyDeleteTaskTaskTaskIdPermanentDelete(
taskId: number,
): CancelablePromise<TaskActionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/task/{task_id}/permanent',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Restore Task
     * Restore an archived task to active status.
 * Only the creator of the task or admins can restore tasks.
 *
 * - **task_id**: The ID of the task to restore
 * - **new_status**: The status to restore the task to (default: OPEN)
     * @param taskId The ID of the task to restore from archive
     * @param requestBody 
     * @returns TaskRestoreResponse Successful Response
     * @throws ApiError
     */
    public static restoreTaskTaskTaskIdRestorePost(
taskId: number,
requestBody?: TaskRestoreRequest,
): CancelablePromise<TaskRestoreResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/{task_id}/restore',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Task Images
     * @param taskId The ID of the task to get images for
     * @returns TaskImage Successful Response
     * @throws ApiError
     */
    public static getTaskImagesTaskTaskIdImagesGet(
taskId: number,
): CancelablePromise<Array<TaskImage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/{task_id}/images',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upload Task Image
     * @param taskId The ID of the task to upload an image for
     * @param formData 
     * @returns TaskImage Successful Response
     * @throws ApiError
     */
    public static uploadTaskImageTaskTaskIdImagesPost(
taskId: number,
formData: Body_upload_task_image_task__task_id__images_post,
): CancelablePromise<TaskImage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/{task_id}/images',
            path: {
                'task_id': taskId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Task Images Base64
     * Get task images as base64 data URLs for PDF generation.
 * This endpoint returns images encoded as base64 strings to avoid CORS issues.
 * No authentication required for PDF generation.
     * @param taskId The ID of the task to get images as base64 for
     * @param imageIds Comma-separated list of image IDs to include (if not provided, all images are returned)
     * @returns TaskImageBase64 Successful Response
     * @throws ApiError
     */
    public static getTaskImagesBase64TaskTaskIdImagesBase64Get(
taskId: number,
imageIds?: string,
): CancelablePromise<Array<TaskImageBase64>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/{task_id}/images/base64',
            path: {
                'task_id': taskId,
            },
            query: {
                'image_ids': imageIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Task Image
     * @param taskId The ID of the task
     * @param imageId The ID of the image to delete
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTaskImageTaskTaskIdImagesImageIdDelete(
taskId: number,
imageId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/task/{task_id}/images/{image_id}',
            path: {
                'task_id': taskId,
                'image_id': imageId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Log Task Opened
     * Log that a user opened/viewed a task
     * @param taskId The ID of the task that was opened
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logTaskOpenedTaskTaskIdOpenPost(
taskId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/{task_id}/open',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Changelog Entries
     * Get all changelog entries across all tasks with pagination and optional task filter
     * @param skip 
     * @param limit 
     * @param taskId 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAllChangelogEntriesTaskChangelogAllGet(
skip?: number,
limit: number = 100,
taskId?: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/changelog/all',
            query: {
                'skip': skip,
                'limit': limit,
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Tasks With Changelog
     * Get all tasks that have changelog entries
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTasksWithChangelogTaskChangelogTasksGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/changelog/tasks',
        });
    }

    /**
     * Create Test Changelog Entry
     * Create a test changelog entry for debugging
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createTestChangelogEntryTaskChangelogTestPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/changelog/test',
        });
    }

    /**
     * Get Task Documents
     * @param taskId The ID of the task to get documents for
     * @returns TaskDocument Successful Response
     * @throws ApiError
     */
    public static getTaskDocumentsTaskTaskIdDocumentsGet(
taskId: number,
): CancelablePromise<Array<TaskDocument>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/{task_id}/documents',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upload Task Document
     * @param taskId The ID of the task to upload a document for
     * @param formData 
     * @returns TaskDocument Successful Response
     * @throws ApiError
     */
    public static uploadTaskDocumentTaskTaskIdDocumentsPost(
taskId: number,
formData: Body_upload_task_document_task__task_id__documents_post,
): CancelablePromise<TaskDocument> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/{task_id}/documents',
            path: {
                'task_id': taskId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Task Document
     * @param taskId The ID of the task
     * @param documentId The ID of the document to delete
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTaskDocumentTaskTaskIdDocumentsDocumentIdDelete(
taskId: number,
documentId: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/task/{task_id}/documents/{document_id}',
            path: {
                'task_id': taskId,
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Email Document
     * Sendet ein Task-Dokument per E-Mail an die angegebenen Empfänger
     * @param taskId The ID of the task
     * @param documentId The ID of the document to email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static emailDocumentTaskTaskIdDocumentsDocumentIdEmailPost(
taskId: number,
documentId: number,
requestBody: DocumentEmailRequest,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/task/{task_id}/documents/{document_id}/email',
            path: {
                'task_id': taskId,
                'document_id': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Contacts
     * Get all contacts from the contact table.
     * Used for autocomplete in invoice creation.
     * @returns Contact[] Successful Response
     * @throws ApiError
     */
    public static getAllContactsTaskContactsAllGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task/contacts/all',
        });
    }

}
